import { combineReducers } from 'redux';
import stepperReducer from './stepperReducer';
import basicDetailsReducer from './basicdetailsReducer';
import othersDetailsReducer from './othersdetailsReducer';
import testingCommisionaReducer from './testingCommissionFieldsReducer';

const testingCommissionReducer = combineReducers({
    stepper: stepperReducer,
    basicDetails:basicDetailsReducer,
    othersDetails:othersDetailsReducer,
    tcDetails:testingCommisionaReducer
});

export default testingCommissionReducer;
